// extracted by mini-css-extract-plugin
export default {"container":"Category_container_FoIxf","icon":"Category_icon_prBsp"};